import CryptoJS from "crypto-js";
const SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY;

export const Decryption = (encryptedValue) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
    const decryptedText = bytes?.toString(CryptoJS?.enc?.Utf8);
    return decryptedText ? JSON.parse(decryptedText) : null;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

export const Encryption = (value) => {
  const encryptedValue = CryptoJS.AES.encrypt(
    JSON.stringify(value),
    SECRET_KEY
  ).toString();
  return encryptedValue;
};
